import { css } from '@emotion/react'
import CloseIcon from '@mui/icons-material/Close'

import { pageSubtitleCss } from '../../../../lib/styles/typography'
import { BP_SMALL_DOWN } from '../../../../lib/styles/breakpoints'
import IconButton from '../../buttons/IconButton'
import { twoDpShadowCss } from '../../../../lib/styles/shadows'
import useTheme from '../../../../lib/hooks/useTheme'
import { getFontColor } from '../../../../lib/colorUtils'

const headerContainerCss = css`
  grid-column: 1 / 3;
  grid-row: 1 / 1;
`
const headerCss = css`
  ${pageSubtitleCss}
  margin-top: 0;
  margin-bottom: 1rem;
`

const closeBtnCss = css`
  display: none;
  color: #fff;

  @media (${BP_SMALL_DOWN}) {
    display: inline-block;
  }
`

type ModalHeaderProps = {
  /** Allow mobile friendly header */
  allowMobile?: boolean
  /** Optional close event for mobile */
  onClose?: () => void
  /** Title of Modal Header */
  title: React.ReactNode
}

const ModalHeader = ({ allowMobile, onClose, title }: ModalHeaderProps) => {
  const { primaryColor } = useTheme()
  const mobileHeaderContainerCss = css`
    @media (${BP_SMALL_DOWN}) {
      align-items: center;
      color: ${getFontColor(primaryColor!)};
      background-color: ${primaryColor};
      display: grid;
      grid-template-columns: auto 48px;
      ${twoDpShadowCss}
      height: 55px;

      & > div {
        color: ${getFontColor(primaryColor!)};
        line-height: 23px;
        margin-bottom: 0;
        margin-left: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  `
  const headerCssSets = [headerContainerCss, allowMobile && mobileHeaderContainerCss]
  return (
    <div css={headerCssSets}>
      <div id="modal_heading" css={headerCss}>
        {title}
      </div>
      {allowMobile && (
        <IconButton ariaLabel="Close" css={closeBtnCss} onClick={onClose}>
          <CloseIcon focusable="false" />
        </IconButton>
      )}
    </div>
  )
}

export default ModalHeader
